module.exports = __webpack_public_path__ + "img/banner-2.6f8e9553.jpg";